<template>
    <div class="block-editor ai-bot-response payload" v-if="clone">
        <div class="says">
            <TiptapEditor
                :show-emoji="true"
                :show-attributes="true"
                :placeholder="$t('automation.botScenario')"
                :max-character-count="6200"
                v-model="clone.prompt"
                :key="'tiptap-prompt' + renderKey"
                automation-mode
            />
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("AskAI");
export default {
    name: "AskAI",
    components: { TiptapEditor },
    props: {
        value: {
            type: Object,
            default: () => ({
                prompt: "",
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            showTemplates: false,
            templates: [],
            renderKey: 0,
        };
    },
    watch: {
        clone: {
            handler(newValue) {
                this.$emit("input", newValue);
            },
            deep: true,
        },
    },
    methods: {
        injectTemplate(slug) {
            const template = this.templates.find((t) => t.slug === slug);
            log("injectTemplate", slug, template);
            if (template) {
                this.clone = {
                    ...this.clone,
                    prompt: template.prompt,
                };
                this.renderKey += 1;
                this.$nextTick();
            }
        },
    },
};
</script>

<style lang="scss">
.block-editor.ai-bot-response {
    padding: 30px 30px 90px;

    .ready-templates {
        display: flex;
        justify-content: flex-end;

        .btnImport {
            color: #006cff;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            cursor: pointer;
            user-select: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .ai-bot-response-header {
        align-items: center;
        display: flex;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 16px;

        .material-icons {
            margin-right: 6px;
        }
    }

    .editable-editor-wrapper {
        border: 1px solid white;
        border-radius: 13px;
        //max-height: 50px;

        .editable-editor {
            //max-height: 50px;

            .ProseMirror {
                //max-height: 50px;
                overflow-y: auto;
            }
        }

        &.focused {
            border-color: #006cff;
        }

        &:hover {
            border-color: #006cff;
        }
    }
}
</style>
